import { Map as ImmutableMap } from 'immutable';
import { handleActions } from 'flux-actions';
import { AppActionTypes } from '../actions/AppActions';
// @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
const initialState = new ImmutableMap({
  editNamePopoverOpen: false,
  addEmailAddressModalOpen: false,
  editEmailAddressModalOpen: false,
  changePasswordModalOpen: false,
  forgotPasswordModalOpen: false,
  addEmailModal: false,
  changePrimaryModal: false,
  logOutAllSessionsModalOpen: false
});
export default handleActions({
  [AppActionTypes.TOGGLE_EDIT_NAME](state) {
    return state.set('editNamePopoverOpen', !state.get('editNamePopoverOpen'));
  },
  [AppActionTypes.TOGGLE_ADD_EMAIL_ADDRESS_MODAL](state) {
    return state.set('addEmailAddressModalOpen', !state.get('addEmailAddressModalOpen'));
  },
  [AppActionTypes.TOGGLE_EDIT_EMAIL_ADDRESS_MODAL](state) {
    return state.set('editEmailAddressModalOpen', !state.get('editEmailAddressModalOpen'));
  },
  [AppActionTypes.TOGGLE_CHANGE_PASSWORD_MODAL](state) {
    return state.set('changePasswordModalOpen', !state.get('changePasswordModalOpen'));
  },
  [AppActionTypes.TOGGLE_FORGOT_PASSWORD_MODAL](state) {
    return state.set('forgotPasswordModalOpen', !state.get('forgotPasswordModalOpen'));
  },
  [AppActionTypes.TOGGLE_EDIT_SIGNATURE_MODAL](state) {
    return state.set('editSignatureModalOpen', !state.get('editSignatureModalOpen'));
  },
  [AppActionTypes.TOGGLE_ADD_EMAIL_MODAL](state) {
    return state.set('addEmailModal', !state.get('addEmailModal'));
  },
  [AppActionTypes.TOGGLE_CHANGE_PRIMARY_MODAL](state) {
    return state.set('changePrimaryModal', !state.get('changePrimaryModal'));
  },
  [AppActionTypes.TOGGLE_LOG_OUT_ALL_SESSIONS_MODAL](state) {
    return state.set('logOutAllSessionsModalOpen', !state.get('logOutAllSessionsModalOpen'));
  }
}, initialState);